<app-modal-generico [modelo]="modalGenerico">
  <div class="table-responsive">
    <app-tablas [headers]="headers" [paginar]="false">
      <tr *ngFor="let item of actividadesEconomicas">
        <td>{{ item.actividad_economica_id }}</td>
        <td>{{ item.desc_actividad_economica }}</td>
        <td>
          {{ item.origen_actividad_economica }}
        </td>
      </tr>
    </app-tablas>
  </div>
  <footer class="text-right p-1">
    <button
      class="btn btn-primary modal-establecimiento-btn-inicio"
      (click)="confirm()"
    >
      Entendido
    </button>
  </footer>
</app-modal-generico>
